import ToTopIcon2 from '@/components/UI/svg/Icons/ToTopIcon2';
import gtm from '@/utils/gtm';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';

// dpux 页面特殊处理
const pages = ['/delta-pro-ultra-x'];

export default function BackToTop() {
    const { pathname } = useRouter();
    const refTop = useRef<any>(null);
    // 滚动到顶部
    const toTopFn = () => {
        if (typeof window === 'undefined') return;
        // 获取当前页面url
        if (pages.includes(pathname)) {
            try {
                const scrollTop = window.sessionStorage.getItem('toTop-scrollTop');
                if (!scrollTop) {
                    window.scrollTo(0, 0);
                } else {
                    const Numb = parseInt(scrollTop);
                    window.scrollTo(0, Numb);
                }
            } catch (e) {
                console.log('数据出错', e);
            }
        } else {
            window.scrollTo(0, 0);
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'bottom_function',
            button_name: 'back_to_top',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', () => {
            const pageYOffset = window.pageYOffset;
            if (pageYOffset > 100) {
                refTop.current && refTop.current.classList && refTop.current.classList.add('show-top');
            } else {
                refTop.current && refTop.current.classList && refTop.current.classList.remove('show-top');
            }
        });
    }, []);
    return (
        <div className="ecoflow-frame-totop ant-back-top" ref={refTop} onClick={toTopFn}>
            <ToTopIcon2 />
        </div>
    );
}
